module.exports = JSON.parse("{\"timestamp\":\"19.10.2026 - 15:03:44\",\"brands\":[]}")